import { Link } from "react-router-dom";

export default function SubServiceBanner({ title }) {
  return (
    <section className="banner pt-11 pb-10 position-relative rounded3 rounded-top-0 breadcrumb mb-0">
      <div className="overlay rounded3 rounded-top-0"></div>

      <div className="container position-relative">
        <div className="banner-inner pt-10 w-lg-75 m-auto text-center text-white">
          
          <div className="section-title mb-2">
            <h1 className="text-white mb-2">{title}</h1>

            <ul className="list-unstyled d-flex justify-content-center">
              <li>
                <Link to="/">Home</Link>
              </li>

              <li className="mx-4">
                <i className="fa fa-star-o green" aria-hidden="true"></i>
              </li>
               <li>
                <Link to="/services">Service</Link>
              </li>

              <li className="mx-4">
                <i className="fa fa-star-o green" aria-hidden="true"></i>
              </li>

              <li>
                <span>{title}</span>
              </li>
            </ul>

          </div>
        </div>
      </div>
    </section>
  );
}
